"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  IDENTITY_CLIENT_ID: true,
  bubbleDuration: true,
  bubbleHeight: true
};
exports.bubbleHeight = exports.bubbleDuration = exports.IDENTITY_CLIENT_ID = void 0;
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _constantsGenerated = require("../constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
const IDENTITY_CLIENT_ID = exports.IDENTITY_CLIENT_ID = 'SPADev';

// Bubble settings
const bubbleDuration = exports.bubbleDuration = 2000;
const bubbleHeight = exports.bubbleHeight = 94;
